import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-line-progress-bar',
    templateUrl: './line-progress-bar.component.html',
    styleUrls: ['./line-progress-bar.component.scss']
})
export class LineProgressBarComponent implements OnInit {

    @Input() stripes = false;
    @Input() progress = 70;

    constructor() { }

    ngOnInit() {
    }

}
